'use strict';

import Helpers from "./Helpers";

const getPriceFromServer = Symbol('getPriceFromServer');
const getWeightFromServer = Symbol('getWeightFromServer');
const getVolumeFromServer = Symbol('getVolumeFromServer');
const getGrillPriceFromServer = Symbol('getGrillPriceFromServer');
const getGrillWeightFromServer = Symbol('getGrillWeightFromServer');
const getGrillVolumeFromServer = Symbol('getGrillVolumeFromServer');
const getAutomationPriceFromServer = Symbol('getAutomationPriceFromServer');
const getAutomationWeightFromServer = Symbol('getAutomationWeightFromServer');
const getAutomationVolumeFromServer = Symbol('getAutomationVolumeFromServer');
const getPowerFromServer = Symbol('getPowerFromServer');
// const getStoreBalanceFromServer = Symbol('getStoreBalanceFromServer');

const convector_types_names = [];
convector_types_names ["ITT"] = "Встраиваемый конвектор";
convector_types_names ["ITTB"] = "Встраиваемый конвектор с вентилятором";
convector_types_names ["ITTL"] = "Встраиваемый конвектор низкого профиля";
convector_types_names ["ITTBL"] = "Встраиваемый конвектор низкого профиля с вентилятором";
convector_types_names ["ITTZ"] = "Встраиваемый конвектор из оцинкованной стали";
convector_types_names ["ITTBZ"] = "Встраиваемый конвектор из оцинкованной стали с вентилятором";
convector_types_names ["ITF"] = "Конвектор";
convector_types_names ["ITW"] = "Настенный конвектор";
const convector_variants_names = [];
convector_variants_names["ITTN"] = "прямого исполнения";
convector_variants_names["ITTBN"] = "прямого исполнения";
convector_variants_names["ITTLN"] = "прямого исполнения";
convector_variants_names["ITTBLN"] = "прямого исполнения";
convector_variants_names["ITTZN"] = "прямого исполнения";
convector_variants_names["ITTBZN"] = "прямого исполнения";
convector_variants_names["ITTC"] = "углового исполнения";
convector_variants_names["ITTBC"] = "углового исполнения";
convector_variants_names["ITTLC"] = "углового исполнения";
convector_variants_names["ITTBLC"] = "углового исполнения";
convector_variants_names["ITTZC"] = "углового исполнения";
convector_variants_names["ITTBZC"] = "углового исполнения";
convector_variants_names["ITTR"] = "радиусного исполнения";
convector_variants_names["ITTBR"] = "радиусного исполнения";
convector_variants_names["ITTLR"] = "радиусного исполнения";
convector_variants_names["ITTBLR"] = "радиусного исполнения";
convector_variants_names["ITTZR"] = "радиусного исполнения";
convector_variants_names["ITTBZR"] = "радиусного исполнения";
const module_adapter_name = "Модуль-адаптер itermic ITTB предназначен для обеспечения управления вентиляторами с обычными асинхронными двигателями переменного тока на 220В с термостатов и прочих 3-х позиционных устройств управления. Номинальная мощность - 150Вт : 0,5мА.";

class KoeffsAndValues {
    constructor() {
        console.log('Init Coefficients calculating module');
    }

    static priceCorner(price, opt, isMiddle = false) {
        if (opt.convector === "ITT" || opt.convector === "ITTB" || opt.convector === "ITTL" || opt.convector === "ITTBL" || opt.convector === "ITTZ" || opt.convector === "ITTBZ")
        {
            let koeff = (isMiddle) ? 2 : 1;
            if (opt.dimensions.shirina === 160 || opt.dimensions.shirina === 200) {
                price += koeff * 3500;
            } else if (opt.dimensions.shirina === 220 || opt.dimensions.shirina === 250) {
                price += koeff * 4000;
            } else if (opt.dimensions.shirina === 280 || opt.dimensions.shirina === 300) {
                price += koeff * 4500;
            } else if (opt.dimensions.shirina === 340 || opt.dimensions.shirina === 350) {
                price += koeff * 4500;
            } else if (opt.dimensions.shirina === 400) {
                price += koeff * 5000;
            }
        }

        return price
    }
    static priceGrillCorner(price, opt, isMiddle = false) {
        if (!opt.no_grill) {
            let koeff = (isMiddle) ? 2 : 1;
            if ((opt.grill === "SGA" || opt.grill === "SGL" || opt.grill === "SGZ" || opt.grill === "SGW" || opt.grill === "SGWL" || opt.grill === "SGWZ" || opt.grill === "PGL" || opt.grill === "PGZ")) {
                if (opt.dimensions.shirina === 160 || opt.dimensions.shirina === 200) {
                    price += koeff * 3700;
                } else if (opt.dimensions.shirina === 220 || opt.dimensions.shirina === 250) {
                    price += koeff * 3800;
                } else if (opt.dimensions.shirina === 280 || opt.dimensions.shirina === 300) {
                    price += koeff * 3900;
                } else if (opt.dimensions.shirina === 340 || opt.dimensions.shirina === 350) {
                    price += koeff * 3900;
                } else if (opt.dimensions.shirina === 400) {
                    price += koeff * 4000;
                }
            } else if (opt.grill === "LGA") {
                if (opt.dimensions.shirina === 160 || opt.dimensions.shirina === 200) {
                    price += koeff * 3200;
                } else if (opt.dimensions.shirina === 220 || opt.dimensions.shirina === 250) {
                    price += koeff * 3300;
                } else if (opt.dimensions.shirina === 280 || opt.dimensions.shirina === 300) {
                    price += koeff * 3500;
                } else if (opt.dimensions.shirina === 340 || opt.dimensions.shirina === 350) {
                    price += koeff * 3500;
                } else if (opt.dimensions.shirina === 400) {
                    price += koeff * 3500;
                }
            }
        }

        return price
    }
    static priceRadial(price, opt) {
        return price * 2.4;
    }
    static priceGrillRadial(price, opt) {
        return price * 2.4;
    }
    static priceNerzh(price, opt) {
        switch (opt.convector)
        {
            case "ITT":
            case "ITTL":
                price *= 1.4;
                break;
            case "ITTB":
            case "ITTBL":
                price *= 1.3;
                break;
        }
        return price;
    }
    static priceDrenazh(price) {
        return price * 1.2;
    }
    static priceSpec(price) {
        return price;
    }
    static priceVent(price) {
        return price * 1.1;
    }
    static priceVent24(price, opt) {
        switch (opt.dimensions.shirina) {
            case 220:
            case 250:
                price *= 1.15;
                break;
            case 280:
            case 300:
                price *= 1.13;
                break;
            case 340:
            case 350:
                price *= 1.11;
                break;
            case 400:
                price *= 1.09;
                break;
        }
        return price;
    }
    static priceForSchemaT(price) {
        return price + 2125;
    }
    static priceRamkaRAL(price) {
        return price * 1;
    }
    static priceGrillRAL(price, opt) {
        return ((!opt.no_grill && (opt.grill === "SGA" || opt.grill === "LGA" || opt.grill === "SGL" || opt.grill === "SGZ" || opt.grill === "PGL" || opt.grill === "PGZ")) ? price * 1.3 : price);
    }
    static priceGrillBlackColor(price, opt) {
        return (!opt.no_grill && opt.grill !== "LGA") ? price * 1.2 : price;
    }
    static powerRadial(power) {
        return power * 0.85;
    }
    static priceGrillSGZBrownGoldChamp(price, opt) {
        return price * 1.1;
    }
    static priceCassete(price, auto) {
        const sections = auto.cassetes.mount_scheme.split("x");
        if (auto.cassetes.color === "Ral")
            price += auto.cassetes.dlina * 100 * (sections[0] * sections[1]) / 1000;
        // Lx100x"Кол-во секций"/1000
        return price;
    }
    static priceToITT(price, auto) {
        const sections = auto.TO_ITT.mount_scheme.split("x");
        if (auto.TO_ITT.color === "Ral")
            price += auto.TO_ITT.dlina * 100 * (sections[0] * sections[1]) / 1000;
        // Lx100x"Кол-во секций"/1000
        return price;
    }
    static priceToITF(price, auto) {
        const sections = auto.TO_ITF.mount_scheme.split("x");
        if (auto.TO_ITF.color === "Ral")
            price += auto.TO_ITF.dlina * 100 * (sections[0] * sections[1]) / 1000;
        // Lx100x"Кол-во секций"/1000
        return price;
    }

    // private methods [] syntax
    // From server
    static [getPriceFromServer] (options, sectionNumber = 1) {
        let result = 0;

        const series = (!options.isFloor || !options.HWoptions) ? options.convector : (options.H ? "ITH" : "ITW")

        $.ajax({
            dataType: "json",
            url: "/front/get_price",
            data: {
                "serie": series,
                "visota": options.dimensions.visota,
                "shirina": options.dimensions.shirina,
                "dlina": (options.isCorner ?
                    ((sectionNumber === 1) ? options.dimensions.dlina1 : ((sectionNumber === 2) ? options.dimensions.dlina2 : options.dimensions.dlina3))
                    : (options.isRadial ? options.dimensions.dlina1 : options.dimensions.dlina))
            },
            async: false
        })
            .done(price => { result = price })
            .fail(data => {  console.log("fail: ", data); })
            .always(() => { /* console.log("always"); */});
        return result;
    }
    static [getWeightFromServer] (options, sectionNumber = 1) {
        let result = 0;
        const series = (!options.isFloor || !options.HWoptions) ? options.convector : (options.H ? "ITH" : "ITW")
        $.ajax({
            dataType: "json",
            url: "/front/get_weight",
            data: {
                "serie": series,
                "visota": options.dimensions.visota,
                "shirina": options.dimensions.shirina,
                "dlina": (options.isCorner ?
                    ((sectionNumber === 1) ? options.dimensions.dlina1 : ((sectionNumber === 2) ? options.dimensions.dlina2 : options.dimensions.dlina3))
                    : (options.isRadial ? options.dimensions.dlina1 : options.dimensions.dlina))
            },
            async: false
        })
            .done(weight => {result = weight})
            .fail(data => {  console.log("fail: ", data); })
            .always(() => { /* console.log("always"); */});

        return result;
    }
    static [getVolumeFromServer] (options, sectionNumber = 1) {
        let result = 0;
        const series = (!options.isFloor || !options.HWoptions) ? options.convector : (options.H ? "ITH" : "ITW")
        $.ajax({
            dataType: "json",
            url: "/front/get_volume",
            data: {
                "serie": series,
                "visota": options.dimensions.visota,
                "shirina": options.dimensions.shirina,
                "dlina": (options.isCorner ?
                    ((sectionNumber === 1) ? options.dimensions.dlina1 : ((sectionNumber === 2) ? options.dimensions.dlina2 : options.dimensions.dlina3))
                    : (options.isRadial ? options.dimensions.dlina1 : options.dimensions.dlina))
            },
            async: false
        })
            .done(volume => {result = volume})
            .fail(data => {  console.log("fail: ", data); })
            .always(() => { /* console.log("always"); */});

        return result;
    }
    static [getAutomationPriceFromServer] (options, variant) {
        let result = 0;

        $.extend(options[variant], {"serie": variant});

        $.ajax({
            dataType: "json",
            url: "/front/get_automation_price",
            data: options[variant],
            async: false
        })
            .done(price => { result = price })
            .fail(data => {  console.log("fail: ", data); })
            .always(() => { /* console.log("always"); */});

        return result;
    }
    static [getAutomationWeightFromServer] (options, variant) {
        let result = 0;

        $.extend(options[variant], {"serie": variant});

        if (variant)
        {
            let s = variant.toUpperCase();
            if (s === "CASSETES" || s === "TO_ITT" || s === "TO_ITF" || s === "SPARES") {
                $.ajax({
                    dataType: "json",
                    url: "/front/get_automation_weight",
                    data: options[variant],
                    async: false
                })
                    .done(weight => {
                        result = weight
                    })
                    .fail(data => {
                        console.log("fail: ", data);
                    })
                    .always(() => { /* console.log("always"); */
                    });
            }
        }

        return result;
    }
    static [getAutomationVolumeFromServer] (options, variant) {
        let result = 0;

        $.extend(options[variant], {"serie": variant});

        if (variant)
        {
            let s = variant.toUpperCase();
            if (s === "CASSETES" || s === "TO_ITT" || s === "TO_ITF") {
                $.ajax({
                    dataType: "json",
                    url: "/front/get_automation_volume",
                    data: options[variant],
                    async: false
                })
                    .done(volume => {
                        result = volume
                    })
                    .fail(data => {
                        console.log("fail: ", data);
                    })
                    .always(() => { /* console.log("always"); */
                    });
            }
        }

        return result;
    }
    static [getGrillPriceFromServer] (options, sectionNumber = 1) {
        let result = 0;

        $.ajax({
            dataType: "json",
            url: "/front/get_price",
            data: {
                "serie": options.grill,
                "visota": options.dimensions.visota,
                "shirina": options.dimensions.shirina,
                "dlina": (options.isCorner ?
                    ((sectionNumber === 1) ? options.dimensions.dlina1 : ((sectionNumber === 2) ? options.dimensions.dlina2 : options.dimensions.dlina3))
                    : (options.isRadial ? options.dimensions.dlina1 : options.dimensions.dlina))
            },
            async: false
        })
            .done(price => {result = price})
            .fail(data => {  console.log("fail: ", data); })
            .always(() => { /* console.log("always"); */});
        return result;
    }
    static [getGrillWeightFromServer] (options, sectionNumber = 1) {
        let result = 0;

        $.ajax({
            dataType: "json",
            url: "/front/get_weight",
            data: {
                "serie": options.grill,
                "visota": options.dimensions.visota,
                "shirina": options.dimensions.shirina,
                "dlina": (options.isCorner ?
                    ((sectionNumber === 1) ? options.dimensions.dlina1 : ((sectionNumber === 2) ? options.dimensions.dlina2 : options.dimensions.dlina3))
                    : (options.isRadial ? options.dimensions.dlina1 : options.dimensions.dlina))
            },
            async: false
        })
            .done(weight => {result = weight})
            .fail(data => {  console.log("fail: ", data); })
            .always(() => { /* console.log("always"); */});
        return result;
    }
    static [getGrillVolumeFromServer] (options, sectionNumber = 1) {
        let result = 0;

        $.ajax({
            dataType: "json",
            url: "/front/get_volume",
            data: {
                "serie": options.grill,
                "visota": options.dimensions.visota,
                "shirina": options.dimensions.shirina,
                "dlina": (options.isCorner ?
                    ((sectionNumber === 1) ? options.dimensions.dlina1 : ((sectionNumber === 2) ? options.dimensions.dlina2 : options.dimensions.dlina3))
                    : (options.isRadial ? options.dimensions.dlina1 : options.dimensions.dlina))
            },
            async: false
        })
            .done(volume => {result = volume})
            .fail(data => {  console.error("fail: ", data); })
            .always(() => { /* console.log("always"); */});
        return result;
    }
    static [getPowerFromServer] (options, sectionNumber = 1) {
        let result = 0;
        let dlina =
            (options.isCorner ?
                (
                    (sectionNumber === 1) ?
                        options.dimensions.dlina1 :
                        (
                            (sectionNumber === 2) ?
                                options.dimensions.dlina2 :
                                options.dimensions.dlina3
                        )
                )
                    :
                (
                    options.isRadial ?
                    options.dimensions.dlina1 :
                    options.dimensions.dlina
                )
            );
        if (options.isCorner) dlina -= options.dimensions.shirina;

        const series = (!options.isFloor || !options.HWoptions) ? options.convector : (options.H ? "ITH" : "ITW")

        $.ajax({
            dataType: "json",
            url: "/front/get_power",
            data: {
                "serie": series,
                "visota": options.dimensions.visota,
                "shirina": options.dimensions.shirina,
                "dlina": dlina
            },
            async: false
        })
            .done(Q_from_server => { result = Q_from_server })
            .fail(data => {  console.log("fail: ", data); });
            // .always(() => {  console.log("always: "); });
        // console.log("Q_from_server: ", result);
        return result;
    }
    // static [getStoreBalanceFromServer] (options) {
    //     let result = 0;
    //     if (options.isCorner) return result;
    //     let dlina = options.dimensions.dlina;
    //     const series = (!options.isFloor || !options.HWoptions) ? options.convector : (options.H ? "ITH" : "ITW")
    //
    //     $.ajax({
    //         dataType: "json",
    //         url: "/front/get_store_balance",
    //         data: {
    //             "serie": series,
    //             "visota": options.dimensions.visota,
    //             "shirina": options.dimensions.shirina,
    //             "dlina": dlina
    //         },
    //         async: false
    //     })
    //         .done(balance_from_server => { result = balance_from_server })
    //         .fail(data => {  console.log("fail: ", data); });
    //     return result;
    // }

    //Final product price (calculated with all the options)
    static getArtikul(options, sectionNumber = 1) {
        let result = String(options.convector);

        result += "." + Helpers.pad(options.dimensions.visota, 3) + "." + options.dimensions.shirina +
            "." + (options.isCorner ?
                ((sectionNumber === 1) ? options.dimensions.dlina1 : ((sectionNumber === 2) ? options.dimensions.dlina2 : options.dimensions.dlina3))
                : (options.isRadial ? options.dimensions.dlina1 : options.dimensions.dlina));

        if (options.isCorner) result += "/C";
        if (options.isRadial) result += "/R" + options.dimensions.dlina2;

        if (options.nerzh) {
            result += "/S";
            if (options.drenazh && !options.isRadial)
                result += "/D";
        }
        if (options.G) result += "/G";
        if (options.spec) result += "/Spec";
        if (options.vent) result += "/V";
        if (options.vent24) result += "/24";

        if (options.isFloor) {
            if (options.HWoptions){
                if (options.H) result += "/H";
                if (options.W) result += "/W";
            }
        }
        if (options.Z_frame) result += "/Z";
        if (options.F_frame) result += "/F";
        if (options.frame_color && options.frame_color !== "Natural") {
            result += ((!options.Z_frame && !options.F_frame) ? "/" : " ") + options.frame_color;
            if (options.frame_color === "Ral") result += " " + options.frame_ral_color;
        }
        if (options.isFloor) {
            if (options.mount_scheme !== "N") result += "/" + options.mount_scheme;
            if (options.visota_nozhki !== 100) result += "/" + options.visota_nozhki;
        }

        if (options.isCorner)
        {
            result += " (" + sectionNumber + ")";
            switch (sectionNumber) {
                case 1:
                    result += options.dimensions.ugol1;
                    break;
                case 2:
                    result += options.dimensions.ugol1;
                    if(options.dimensions.dlina3) result += "^" + options.dimensions.ugol2;
                    break;
                case 3:
                    result += options.dimensions.ugol2;
            }
        }

        return result;
    }
    static getGrillArtikul(options, sectionNumber = 1) {
        let result = "GRILL." + options.grill + ((options.isCorner) ? "C" : ((options.isRadial) ? "R" : "")) + "-";

        result += options.dimensions.shirina / 10 + "-";

        if (options.isCorner)
            result += ((sectionNumber === 1) ? options.dimensions.dlina1 : ((sectionNumber === 2) ? options.dimensions.dlina2 : options.dimensions.dlina3));
        else
            result += (options.isRadial ? (options.dimensions.dlina1 + "/" + options.dimensions.dlina2) : options.dimensions.dlina);

        result += "/" + (options.grill_color === "Ral" ? options.grill_color + " " + options.grill_ral_color : options.grill_color);

        if (options.isCorner)
        {
            result += " (" + sectionNumber + ")";
            switch (sectionNumber) {
                case 1:
                    result += options.dimensions.ugol1;
                    break;
                case 2:
                    result += options.dimensions.ugol1;
                    if(options.dimensions.dlina3) result += "^" + options.dimensions.ugol2;
                    break;
                case 3:
                    result += options.dimensions.ugol2;
            }
        }

        return result;
    }
    static getModuleArtikul(options) {
        return "Модуль-адаптер ITTB";
    }
    static getModule24VArtikul(options) {
        return "Модуль-адаптер ITTB-24";
    }
    static getBPArtikul(options) {
        return "Блок питания";
    }
    static getAutomationArtikul(options, variant) {
        let result = options[variant].name;
        switch (variant) {
            case "spares":
                if (options[variant].units)
                    result += " (" + options[variant].units + ")";
                break;
            case "cassetes":
                result += "." + options[variant].mount_scheme;
                result += "." + options[variant].dlina;
                if (options[variant].step !== 8)
                    result += "/" + options[variant].step
                if (options[variant].color === "Ral")
                    result += "/Ral " + options[variant].color_ral;
                break;
            case "TO_ITT":
                result += "." + options[variant].mount_scheme;
                result += "." + options[variant].dlina;
                if (options[variant].mf)
                    result += "/MF"
                if (options[variant].step !== 8)
                    result += "/" + options[variant].step
                if (options[variant].color === "Ral")
                    result += "/Ral " + options[variant].color_ral;
                break;
            case "TO_ITF":
                result += "." + options[variant].mount_scheme;
                result += "." + options[variant].dlina;
                if (options[variant].color === "Ral")
                    result += "/Ral " + options[variant].color_ral;
                if (options[variant].prisoed !== "X")
                    result += "/" + options[variant].prisoed;
                break;
        }

        return result;
    }

    static getConvectorDescription(options, sectionNumber = 1) {
        let result = String(convector_types_names[options.convector]);

        result += " itermic серии " + options.convector
            + (options.isFloor ? (options.W ? " настенного крепления" : "") : (", " + convector_variants_names[options.variant]))
            + (options.nerzh ? ", с корпусом из нержавеющей стали" + ((options.drenazh && !options.isRadial) ? ", с дренажом" : "") : "")
            + (options.G ? ", с опцией G" : "")
            + (options.spec ? ", с нестандартным соединением корпусов" : "")
            + (options.vent ? ", для систем вентиляции" : "")
            + (options.Z_frame ? ", с Z-образной рамкой" : "")
            + (options.F_frame ? ", с F-образной рамкой" : "")
            + (options.isFloor ? "" : (", цвета рамки " + options.frame_color + (options.frame_color === "Ral" ? options.frame_ral_color : "")))
            + ", высотой " + Helpers.pad(options.dimensions.visota) + " мм"
            + ", шириной " + options.dimensions.shirina + " мм"
            + ", длиной "
            + (options.isCorner
                ? (sectionNumber + "-й секции " + (sectionNumber === 1 ? options.dimensions.dlina1 : (sectionNumber === 2 ? options.dimensions.dlina2 : (sectionNumber === 3 ? options.dimensions.dlina3 : 0))))
                : (options.isRadial ? ("внешней дуги " + options.dimensions.dlina1) : options.dimensions.dlina))
            + " мм"
            + (options.isRadial ? ", внутренним радиусом " + options.dimensions.dlina2 + " мм": "");

        if (options.isCorner)
        {
            switch (sectionNumber) {
                case 1:
                    result += ", угловой элемент " + options.dimensions.ugol1;
                    break;
                case 2:
                    if(options.dimensions.dlina3)
                        result += ", угловые элементы " + options.dimensions.ugol1 + " и " + options.dimensions.ugol2;
                    else
                        result += ", угловой элемент " + options.dimensions.ugol1;
                    break;
                case 3:
                    result += ", угловой элемент " + options.dimensions.ugol2;
            }
            result += " град";
        }

        result += ". Мощность прибора ";
        switch (sectionNumber) {
            case 1:
                result += (options.vent) ? options.Q.Vent_Q1 : options.Q.Q1;
                break;
            case 2:
                result += (options.vent) ? options.Q.Vent_Q2 : options.Q.Q2;
                break;
            case 3:
                result += (options.vent) ? options.Q.Vent_Q3 : options.Q.Q3;
                break;
        }
        result += " Вт, при температуре на входе " + options.temperatures.input_t + "°C, температуре на выходе " + options.temperatures.output_t + "°C и температуре помещения " + options.temperatures.room_t + "°C";
        // + ". Вес прибора: " + $convector_weight.toFixed(2) + " кг"
        // + ". Объём прибора: " + $convector_volume.toFixed(4) + " куб.м"
        result += (options.isFloor ? (". Цвет конвектора: " + options.frame_color + ".") : ".");

        return result;
    }
    static getGrillDescription(options, sectionNumber = 1) {
        let result = String("Решётка itermic серии " + options.grill);

        if (options.isRadial)
            result += ", " + convector_variants_names[options.variant];

        if (options.isCorner)
        {
            switch (sectionNumber) {
                case 1:
                    result += " с угловым элементом " + options.dimensions.ugol1;
                    break;
                case 2:
                    if(options.dimensions.dlina3)
                        result += " с угловыми элементами " + options.dimensions.ugol1 + " и " + options.dimensions.ugol2;
                    else
                        result += " с угловым элементом " + options.dimensions.ugol1;
                    break;
                case 3:
                    result += " с угловым элементом " + options.dimensions.ugol2;
            }
            result += " град";
        }

        result +=  ", шириной " + options.dimensions.shirina + " мм"
            + ", длиной "
            + (options.isCorner
                ? (sectionNumber + "-й секции " + (sectionNumber === 1 ? options.dimensions.dlina1 : (sectionNumber === 2 ? options.dimensions.dlina2 : (sectionNumber === 3 ? options.dimensions.dlina3 : 0))))
                : options.dimensions.dlina)
            + " мм"
            + " и цвета " + (options.grill_color === "Ral" ? options.grill_color + " " + options.grill_ral_color : options.grill_color)
        ;

        return result;
    }
    static getModuleDescription(options) {
        return module_adapter_name + " для " + options.convector;
    }
    static getModule24VDescription(options) {
        return "";
    }
    static getBPDescription(options) {
        return "";
    }
    static getAutomationDescription(options, variant) {
        let result = options[variant].name;
        switch (variant) {
            case "servos":
            case "spares":
            case "controllers":
                break;
            case "blowers":
                result ="Вентилятор " + result + ", " + options[variant].power + "Вт";
                break;
            case "TO_ITT":
                result ="Теплообменник " + result;
                result += "." + options[variant].mount_scheme;
                result += "." + options[variant].dlina;
                if (options[variant].mf)
                    result += "/MF"
                if (options[variant].step !== 8)
                    result += "/" + options[variant].step
                if (options[variant].color === "Ral")
                    result += "/Ral " + options[variant].color_ral;
                break;
            case "TO_ITF":
                result ="Теплообменник " + result;
                result += "." + options[variant].mount_scheme;
                result += "." + options[variant].dlina;
                if (options[variant].color === "Ral")
                    result += "/Ral " + options[variant].color_ral;
                if (options[variant].prisoed !== "X")
                    result += "/" + options[variant].prisoed;
                break;
            case "cassetes":
                result ="Кассета " + result;
                result += "." + options[variant].mount_scheme;
                result += "." + options[variant].dlina;
                if (options[variant].step !== 8)
                    result += "/" + options[variant].step
                if (options[variant].color === "Ral")
                    result += "/Ral " + options[variant].color_ral;
                break;
        }
        return result;
    }

    static getConvectorPrice(options, sectionNumber = 1) {
        let result = this[getPriceFromServer](options, sectionNumber);

        if (options.isCorner)
            result = this.priceCorner(result, options, ((sectionNumber === 2) && options.dimensions.dlina3));
        else if (options.isRadial)
            result = this.priceRadial(result, options);

        if (options.nerzh) {
            result = this.priceNerzh(result, options);
            if (options.drenazh && !options.isRadial)
                result = this.priceDrenazh(result);
        }

        if (options.spec)
            result = this.priceSpec(result);

        if (options.vent && !options.isRadial)
            result = this.priceVent(result);

        if (!options.isFloor && options.frame_color === "Ral")
            result = this.priceRamkaRAL(result);

        if (options.isFloor &&
            (options.mount_scheme === "T" ||
            options.mount_scheme === "TP" ||
            options.mount_scheme === "TPN")
        )
            result = this.priceForSchemaT(result)

        if (options.hasBlower && options.vent24) {
            result = this.priceVent24(result, options);
        }

        return result;
    }
    static getGrillPrice(options, sectionNumber = 1) {
        let result = this[getGrillPriceFromServer](options, sectionNumber);
        if (!options.no_grill && (options.grill === "SGZ" || options.grill === "PGZ") && (options.grill_color === "Brown" || options.grill_color === "Gold" || options.grill_color === "Champ"))
            result = this.priceGrillSGZBrownGoldChamp(result, options);

        if (options.isCorner)
            result = this.priceGrillCorner(result, options, ((sectionNumber === 2) && options.dimensions.dlina3));
        else if (options.isRadial)
            result = this.priceGrillRadial(result, options);

        if (options.grill_color === "Ral")
            result = this.priceGrillRAL(result, options);

        if (options.grill_color === "Black")
            result = this.priceGrillBlackColor(result, options);

        return result;
    }
    static getModulePrice(options) {
        return 6350;
    }
    static getModule24VPrice(options) {
        return 9050;
    }
    static getBPPrice(options) {
        return 5000;
    }
    static getAutomationPrice(options, selection) {
        let result = this[getAutomationPriceFromServer](options, selection);
        if (options.cassetes) {
            result = this.priceCassete(result, options);
        }
        if (options.TO_ITT) {
            result = this.priceToITT(result, options);
        }
        if (options.TO_ITF) {
            result = this.priceToITF(result, options)
        }
        return result;
    }

    static getConvectorWeight(options, sectionNumber = 1) {
        return this[getWeightFromServer](options, sectionNumber);
    }
    static getGrillWeight(options, sectionNumber = 1) {
        return this[getGrillWeightFromServer](options, sectionNumber);
    }
    static getAutomationWeight(options, selection) {
        return this[getAutomationWeightFromServer](options, selection);
    }

    static getConvectorVolume(options, sectionNumber = 1) {
        return this[getVolumeFromServer](options, sectionNumber);
    }
    static getGrillVolume(options, sectionNumber = 1) {
        return this[getGrillVolumeFromServer](options, sectionNumber);
    }
    static getAutomationVolume(options, selection) {
        return  this[getAutomationVolumeFromServer](options, selection);
    }

    static getConvectorPower(options, sectionNumber = 1) {
        // return 187;
        let result = this[getPowerFromServer](options, sectionNumber);

        if (options.isRadial)
            result = this.powerRadial(result);

        return result;
    }
    static getKoeffOfDelta_t (options) {
        // return 1.47;
        let result = 1;

        const series = (!options.isFloor || !options.HWoptions) ? options.convector : (options.H ? "ITH" : "ITW")

        $.ajax({
            dataType: "json",
            url: "/front/get_napor",
            data: {
                "serie": series,
                "visota": options.dimensions.visota,
                "shirina": options.dimensions.shirina
            },
            async: false
        })
            .done(koeff_from_server => {result = koeff_from_server;})
            .fail(data => {  console.log("fail: ", data); })
            .always(data => { /* console.log(data); */});

        return result;
    }
    static getKv(options) {
        if (!options.vent) return 0;
        return {
            Kv1: 1 + 0.08 * Math.pow(options.vent_option.prit_raskh / (((options.isCorner || options.isRadial) ? options.dimensions.dlina1 : options.dimensions.dlina ) / 1000), 0.7),
            Kv2: 1 + 0.08 * Math.pow(options.vent_option.prit_raskh / (options.dimensions.dlina2 / 1000), 0.7),
            Kv3: 1 + 0.08 * Math.pow(options.vent_option.prit_raskh / (options.dimensions.dlina3 / 1000), 0.7),
        }
    }
    static getKt(options, temperatures, napor) {
        if (!options.vent) return 0;
        const average_t = (temperatures.input_t + temperatures.output_t) / 2;
        return Math.pow((average_t - options.vent_option.prit_t) / (average_t - temperatures.room_t), napor);
    }

    static getItfConvectorSizes() {
        return {
            itf: {
                visotas: [80, 130, 200, 300],
                shirinas: [80, 130, 200, 250]
            },
            ith: {
                visotas: [80, 130, 200, 300],
                shirinas: [150, 200, 250]
            },
            itw: {
                visotas: [200, 300, 400, 500, 600],
                shirinas: [100, 150]
            },
        }
    }

    // static getStoreBalance(options) {
    //     return this[getStoreBalanceFromServer](options)
    // }
}

export default KoeffsAndValues;